<script lang="ts" setup>
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
});

defineExpose({
  label: props.label,
});
</script>

<template>
  <div class="float-navigator-item">
    <slot></slot>
  </div>
</template>
